export enum ENavigationErrorType {
    IE = 1,
    UnAuthenticated = 2,
    UnAuthorized = 3,
}
